module.exports = __webpack_public_path__ + "img/osa.0f347f75.svg";